import gql from 'graphql-tag';

export const CompletePayment = gql`
  mutation completePayment($orderNumber: String!, $language: String!, $paymentMethod: String!) {
    completePayment(payment: { orderNumber: $orderNumber, language: $language, paymentMethod: $paymentMethod }) {
      payment {
        id
        payId
        status
        description
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/GatewayComponent/CompletePayment.tsx